export default __webpack_public_path__ + "static/media/linux_logo.9b8a4613.png";